import React from 'react'

function NotifyPayment() {
  return (
    <div className="bg-white h-screen">

      <div className="max-w-7xl mx-auto text-center py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
        <div className="bg-white rounded-[10px] py-5 lg:py-0 border-b border-gray-200 lg:px-0 px-6">
          <div className="!m-0 overflow-x-auto sm:-mx-6 lg:-mx-8 bg-white rounded-[10px] gap-5 shadow-lg p-5  mt-5 ">
            <div className=" py-6 px-6 sm:px-6">

              <div className="py-2 text-2xl font-medium ">
                Notificar Pagos
              </div>
              <div className=" text-lg font-regular ">
                {" "}
                Dirígete al portal anterior para notificar tus pagos
              </div>
            </div>
            <>
              <div className="mt-8 flex justify-center">
                <div className="ml-3 inline-flex">
                  <a
                    href="https://www.netuno.net.ve/cuenta/login"
                    target='_blank'
                    className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200"
                  >
                    Ir al portal anterior
                  </a>
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotifyPayment